import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {PayorInterface} from '../interfaces/payor.interface';
import {ITripReasonTransportHistory} from '../interfaces/reason-transport.interface';

@Injectable()
export class PayorService extends ParentService {

  constructor(
    private _http: Http
  ) {
    super();
  }

  /**
   * @type get
   * @description list payor
   */
  get (showInactive: boolean = false): Observable<PayorInterface[]> {
    return this._http.get(`${constant.URL_PAYOR_LIST}?showInactive=${showInactive}`, this.getHeader())
      .pipe(
        map((response: any) => response.json() as PayorInterface[])
    );

  }

  getTypePayorsInactive(payorType: number, isActive: boolean): Observable<PayorInterface[]> {
    const url = `${constant.URL_PAYOR_LIST}?showInactive=${isActive}&payorTypeId=${payorType}`;
    return this._http.get(url, this.getHeader()).map(response => response.json())
    .catch(error => Observable.throw(error.json()));
  }

  getTripReasonTransportHistory(tripReasonTransportId: number): Observable<ITripReasonTransportHistory[]> {
    const url = `${constant.URL_REASON_TRANSPORT_HISTORY}/${tripReasonTransportId}`;
    return this._http.get(url, this.getHeader()).map(response => response.json())
    .catch(error => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/payor.service.ts